import { ErrorComponent } from '@openx/components-core/lib/Error/Error';
import { FailureImage } from '@openx/components-core/lib/Error/pictures/Failure';
import React from 'react';
import { getRollbar } from '../../modules/analytics/rollbar';

interface StateProps {
  hasError: boolean;
}

interface ErrorBoundaryProps {
  children?: React.ReactNode;
  className?: string;
}

class ErrorBoundaryRawComponent extends React.Component<ErrorBoundaryProps, StateProps> {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info): void {
    // biome-ignore lint/suspicious/noConsole: logging info in console
    console.error('ErrorBoundary', error, info);
    const rollbar = getRollbar();
    if (rollbar) {
      rollbar.error('Caught by the ErrorBoundary', { error, info });
    }
  }

  reloadPage = (): void => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <ErrorComponent
          title="Ooops!"
          titlePrefix="OpenXSelect"
          subtitle="Something went wrong. Please refresh your browser."
          actions={[
            {
              children: 'Refresh',
              color: 'secondary',
              'data-test': 'button-refresh',
              onClick: this.reloadPage,
              variant: 'contained',
            },
          ]}
          PictureComponent={FailureImage}
          className={this.props.className}
          data-test="error-refresh"
        />
      );
    }

    return this.props.children;
  }
}

export const ErrorBoundary = ErrorBoundaryRawComponent;
